import React, { useState } from 'react';
import { EyeIcon } from './icons';
import { Field } from './FormPage';
import PasswordRequirements from '../../../components/Auth/PasswordRequirements';

interface PasswordInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: 'current-password' | 'new-password';
  disabled?: boolean;
  invalid?: boolean;
  /** Показать чек-лист требований к паролю прямо под полем */
  showRequirements?: boolean;
  error?: React.ReactNode;
  hint?: React.ReactNode;
}

/** Поле пароля с кнопкой «показать» и (по желанию) подсказкой требований сразу под полем. */
export const PasswordInput: React.FC<PasswordInputProps> = ({
  id, label, value, onChange, autoComplete = 'current-password', disabled, invalid, showRequirements, error, hint,
}) => {
  const [visible, setVisible] = useState(false);
  return (
    <Field label={label} htmlFor={id} error={error} hint={hint}>
      <div className="form-page__control">
        <input
          id={id}
          className={`form-page__input form-page__input--with-action${invalid ? ' form-page__input--invalid' : ''}`}
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete={autoComplete}
          aria-invalid={invalid || undefined}
          disabled={disabled}
          required
        />
        <button
          type="button"
          className="form-page__eye"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? 'Скрыть пароль' : 'Показать пароль'}
          aria-pressed={visible}
          title={visible ? 'Скрыть пароль' : 'Показать пароль'}
        >
          <EyeIcon off={visible} />
        </button>
      </div>
      {showRequirements && <PasswordRequirements password={value} />}
    </Field>
  );
};
